import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "common-layout"
};
const _hoisted_2 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  key: 1
};
const _hoisted_5 = {
  class: "demonstration",
  style: {
    "margin": "10px 0"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_header = _resolveComponent("el-header");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_table = _resolveComponent("el-table");
  const _component_el_main = _resolveComponent("el-main");
  const _component_el_pagination = _resolveComponent("el-pagination");
  const _component_el_footer = _resolveComponent("el-footer");
  const _component_el_container = _resolveComponent("el-container");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_container, null, {
    default: _withCtx(() => [_createVNode(_component_el_header, null, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
        type: "primary",
        plain: "",
        onClick: $options.add,
        style: {
          "position": "relative",
          "left": "0px",
          "margin-right": "10px"
        }
      }, {
        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode("生成符合性声明", -1)]))]),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_el_input, {
        modelValue: $data.unit,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.unit = $event),
        style: {
          "width": "20%"
        },
        maxlength: "50",
        "show-word-limit": "",
        placeholder: "输入使用单位",
        clearable: ""
      }, null, 8, ["modelValue"]), _createVNode(_component_el_input, {
        modelValue: $data.orderNo,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.orderNo = $event),
        style: {
          "width": "20%"
        },
        maxlength: "50",
        "show-word-limit": "",
        placeholder: "输入工单号",
        clearable: ""
      }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
        type: "primary",
        plain: "",
        onClick: $options.load
      }, {
        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("查询", -1)]))]),
        _: 1
      }, 8, ["onClick"])])]),
      _: 1
    }), _createVNode(_component_el_main, {
      style: {
        "margin-top": "0px"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_el_table, {
        data: $data.tableData,
        style: {
          "width": "100%",
          "height": "475px"
        },
        border: "",
        "row-class-name": $options.tableRowClassName,
        onSelectionChange: $options.handleSelectionChange
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          type: "selection",
          width: "55"
        }), _createVNode(_component_el_table_column, {
          prop: "orderNo",
          label: "工单号"
        }), _createVNode(_component_el_table_column, {
          prop: "unit",
          label: "使用单位"
        }), _createVNode(_component_el_table_column, {
          prop: "reportResult",
          label: "报告结论"
        }, {
          default: _withCtx(scope => [scope.row.reportResult == 0 ? (_openBlock(), _createElementBlock("span", _hoisted_3, "符合")) : _createCommentVNode("", true), scope.row.reportResult == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_4, "不符合")) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "liftNum",
          label: "产品编号"
        }), _createVNode(_component_el_table_column, {
          prop: "loginNum",
          label: "使用登记证编码"
        }), _createVNode(_component_el_table_column, {
          prop: "lifeCode",
          label: "设备代码"
        }), _createVNode(_component_el_table_column, {
          prop: "unitNum",
          label: "单位内编码"
        })]),
        _: 1
      }, 8, ["data", "row-class-name", "onSelectionChange"])]),
      _: 1
    }), _createVNode(_component_el_footer, null, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_pagination, {
        currentPage: $data.currentPage,
        "onUpdate:currentPage": _cache[2] || (_cache[2] = $event => $data.currentPage = $event),
        "page-size": $data.pageSize,
        "onUpdate:pageSize": _cache[3] || (_cache[3] = $event => $data.pageSize = $event),
        "page-sizes": [20, 40, 60],
        small: $data.small,
        background: $data.background,
        layout: "total, sizes, prev, pager, next, jumper",
        total: $data.total,
        prev: $data.prev,
        pager: $data.pager,
        next: $data.next,
        jumper: $data.jumper,
        onSizeChange: $options.handleSizeChange,
        onCurrentChange: $options.handleCurrentChange
      }, null, 8, ["currentPage", "page-size", "small", "background", "total", "prev", "pager", "next", "jumper", "onSizeChange", "onCurrentChange"])])]),
      _: 1
    })]),
    _: 1
  })]);
}